export default [
  {
    'id': 1,
    'number': '000001',
    'created_date': '2018-05-01 10:09',
    'customer_name': 'Ionescu Vasile',
    'status': 'completed',
    'delivery_service': 'Pick up',
    'type': 'group',
    'total': 123.45,
    'currency': 'lei',
    'address': {
      'billing': {
        'id': 10,
        'type': 'billing',
        'street': 'Zorelelor 12',
        'city': 'Oradea',
        'state': 'Bihor',
        'country': 'RO'
      },
      'shipping': {
        'id': 11,
        'type': 'shipping',
        'street': 'Zorelelor 12',
        'city': 'Oradea',
        'state': 'Bihor',
        'country': 'RO'
      }
    }
  },
  {
    'id': 2,
    'number': '000002',
    'created_date': '2018-05-01 09:09',
    'customer_name': 'Vickie Kiehn',
    'status': 'new',
    'delivery_service': 'Half way',
    'type': 'single',
    'total': 52.00,
    'currency': 'lei',
    'county': 'Bihor'
  },
  {
    'id': 3,
    'number': '000003',
    'created_date': '2018-05-01 08:09',
    'customer_name': 'Ronny McDonalds',
    'status': 'canceled',
    'delivery_service': 'At home',
    'type': 'single',
    'total': 64.30,
    'currency': 'lei',
    'county': 'Bihor'
  }
]



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Orders/orders.js